export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'd1fd3e1', dateTime: 1789511526609 };